module.exports = __webpack_public_path__ + "static/media/propic-first.0a9a14d3.png";